import React from "react";
import SysStoreDetail from "../component/SysStoreDetail";

const SysStoreDetailContainer = ({ pageId }) => (<SysStoreDetail pageId={pageId} />)

export default SysStoreDetailContainer;
